import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded'
import AddRoundedIcon from '@material-ui/icons/AddRounded'
import InputBase from '@material-ui/core/InputBase'

const NumberStepper = ({ min, max, value, onChange }) => {
  const [numberValue, setNumberValue] = useState(value)
  const changeNumber = useCallback(
    (count) => {
      if (count > 0 && numberValue >= max) {
        return false
      }
      if (count < 0 && numberValue <= min) {
        return false
      }
      setNumberValue(numberValue + count)
      onChange(numberValue + count)
    },
    [max, min, numberValue, onChange]
  )
  const InputValueChange = (e) => {
    const inputValue = e.nativeEvent.target.value
    const finalValue = (() => {
      if (inputValue > max) return max
      if (inputValue < min) return min
      return inputValue
    })()

    setNumberValue(finalValue)
    onChange(finalValue)
  }
  return (
    <StepperWapper>
      <Minus disabled={numberValue <= min} onClick={() => changeNumber(-1)} />
      <NumberInput
        type="number"
        value={numberValue}
        onChange={InputValueChange}
      />
      <Plus disabled={numberValue >= max} onClick={() => changeNumber(1)} />
    </StepperWapper>
  )
}

const StepperWapper = styled.div`
  display: flex;
  border-radius: 50px;
  border: 1px solid ${(p) => p.theme.color.grey80};
  background-color: ${(p) => p.theme.color.white};
  justify-content: space-between;
  align-items: center;
  width: 100px;
  /* height: 32px; */
`
const Minus = styled(RemoveRoundedIcon)`
  color: ${(p) => (p.disabled ? p.theme.color.grey80 : p.theme.color.blue200)};
  cursor: ${(p) => !p.disabled && 'pointer'};
  font-size: 16px !important;
  width: 32px !important;
`
const NumberInput = styled(InputBase)`
  color: ${(p) => p.theme.color.dark100};
  input {
    text-align: center;
    appearance: none;
  }
  /* stylelint-disable property-no-vendor-prefix */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
`

const Plus = styled(AddRoundedIcon)`
  color: ${(p) => (p.disabled ? p.theme.color.grey80 : p.theme.color.blue200)};
  cursor: ${(p) => !p.disabled && 'pointer'};
  font-size: 16px !important;
  width: 32px !important;
`

export default NumberStepper
